import React from "react";
import cn from "clsx";
import classes from "./Header.module.css";
import Container from "src/components/ui-kit/Container";
import Typography from "src/components/ui-kit/Typography/Typography";
import Partners from "src/components/Partners";
import { useStaticQuery, graphql } from "gatsby";
import { HeaderQuery } from "types/graphql-types";
import Img, { FixedObject } from "gatsby-image";

interface HeaderProps {}

const scrollToSecondBlock = () => {
  const elmnt = document.getElementById("second-block");
  if (!elmnt) {
    return;
  }
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: elmnt.offsetTop,
  });
};

const Header: React.FC<HeaderProps> = () => {
  const data: HeaderQuery = useStaticQuery(graphql`
    query Header {
      file(relativePath: { eq: "Header/background.jpg" }) {
        childImageSharp {
          fixed(width: 562, height: 640) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);

  return (
    <nav className={cn(classes.container)}>
      <Container>
        <div className={cn(classes.logos)}>
          <Partners />
        </div>
        <Typography
          className={cn(classes.heading)}
          variant="h1"
          color="inverted"
        >
          Двери не
          <br /> закрываются
        </Typography>
        <Typography
          className={cn(classes.headingSecond)}
          variant="h2"
          color="inverted"
        >
          Благотворительный
          <br />
          марафон
        </Typography>
        <Typography
          className={cn(classes.headingSecondMobile)}
          variant="p"
          component="h2"
          color="inverted"
        >
          Благотворительный марафон
        </Typography>
        <button
          className={cn(classes.buttonScroll)}
          onClick={scrollToSecondBlock}
        >
          <img
            src={require("./assets/arrow-down.png")}
            alt="Промотать страницу вниз"
            height="60px"
            tabIndex={-1}
          />
        </button>
        <Container className={classes.buttonScrollMobileContainer}>
          <button
            className={cn(classes.buttonScroll)}
            onClick={scrollToSecondBlock}
          >
            <img
              src={require("./assets/arrow-down.png")}
              alt="Промотать страницу вниз"
              height="60px"
              tabIndex={-1}
            />
          </button>
        </Container>

        <img
          alt="Собака на розовом фоне"
          src={require("./assets/background.jpg")}
          className={cn(classes.background)}
        />
      </Container>
    </nav>
  );
};

export default Header;
